import type { AssistantCitation } from "@cmmd-forge/contracts";
import type { AssistantCitationSourceAnchor } from "../../lib/assistantTextSelection";
import { createContext, useContext } from "react";

export type CiteAssistantText = (
  citation: AssistantCitation,
  sourceAnchor: AssistantCitationSourceAnchor,
) => boolean;

interface ThreadComposerLayoutState {
  readonly registerCitationEditor: (handler: CiteAssistantText) => () => void;
  readonly citeAssistantText: CiteAssistantText;
  readonly timelineInset: number;
  readonly overlayHeight: number;
  readonly publishOverlayHeight: (height: number) => void;
  readonly setResting: (resting: boolean) => void;
}

export const ThreadComposerLayoutContext = createContext<ThreadComposerLayoutState>({
  registerCitationEditor: () => () => {},
  citeAssistantText: () => false,
  timelineInset: 0,
  overlayHeight: 0,
  setResting: () => {},
  publishOverlayHeight: () => {},
});

export function useThreadComposerLayout() {
  return useContext(ThreadComposerLayoutContext);
}
